import Text from '../Text';

const Quote = ({ children }) => {
  return <Text type='quote'>{children}</Text>;
};

export default Quote;
